import { render, staticRenderFns } from "./QCollapse.vue?vue&type=template&id=bf60962a&"
import script from "./QCollapse.vue?vue&type=script&lang=js&"
export * from "./QCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports